import { IDashboardComponent } from "api/model/dashboard/DashboardComponent";

const getDashboardComponentClassName = (component: IDashboardComponent, isGroupHeader?: boolean) => {
  const currentClassName = `easas-dashboard-component${isGroupHeader ? "-group-header" : ""}`;

  if (component.config.theme === "dark" || component.config.theme === "transparent") {
    return currentClassName.concat(`-${component.config.theme}`);
  }

  return currentClassName;
};

export default getDashboardComponentClassName;
